<template>
  <div>
    <vue-typeahead-bootstrap
      v-model="model"
      :prepend="prepend"
      @keyup="onGetSeries"
      :data="optionsText"
      :inputClass="errors.length ? 'is-invalid' : ''"
      placeholder="ระบุรุ่น"
      @hit="onSelected"
      :disabled="isDisabled"
      :maxLength = "maxLength"
    >
      <template v-slot:feedback>
        <span
          v-if="model"
          class="badge input-validate-length"
          :class="{
            'badge-success': model.length !== maxLength,
            'badge-danger': model.length === maxLength,
          }"
          style="bottom:20px"
          >{{ model.length }}/{{ maxLength }}</span
        >
        <!-- <div style="bottom:-30px">
          <span class="form-text validate-textbox d-block">
            ถ้าเป็นสินค้าไม่มีรุ่นให้เลือก Non-Series
          </span>
          <span class="validate-invalid" v-if="errors.length">
            {{ errors[0] }}
          </span>
        </div> -->
        <div
          style="width: 100%;margin-top: 0.25rem;font-size: 80%;"
          class="d-block"
        >
          ถ้าเป็นสินค้าไม่มีรุ่นให้เลือก Non-Series
        </div>
        <div
          style="width: 100%;font-size: 80%; color:#f46a6a; height: 10px;"
          class="mb-1"
        >
          <span v-show="errors.length">{{ errors[0] }}</span>
          &nbsp;
        </div>
        <!-- <slot name="validateTextbox"></slot> -->
      </template>
      <template slot="suggestion" slot-scope="{ data, htmlText }">
        <span class="badge-lang">TH</span>
        {{ options.find(x => x.display_name[lang] === data).display_name.th }}
        <br />
        <span class="badge-lang">EN</span>
        {{ options.find(x => x.display_name[lang] === data).display_name.en }}
      </template>
    </vue-typeahead-bootstrap>
  </div>
</template>

<script>
import VueTypeaheadBootstrap from '@/components/share/vue-typeahead-bootstrap/index.vue'
import seriesService from '@/helpers/service/series-service'

export default {
  components: {
    'vue-typeahead-bootstrap': VueTypeaheadBootstrap,
    // Multiselect,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    prepend: {
      type: String,
      default: '',
    },
    maxLength: {
      type: Number,
      default: 30,
    },
    errors: {
      type: Array,
      default: () => [],
    },
    lang: {
      type: String,
      default: 'th',
      required: true,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      pageSize: 15,
      optionsText: [],
      options: [],
      selectedSeries: {},
    }
  },
  computed: {
    model: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },
  methods: {
    async onGetSeries() {
      if (this.model.length < 3) {
        return
      }
      const keyword = this.value.trim()

      let params = new URLSearchParams()
      params.append('pageSize', this.pageSize)
      params.append('sort', `display_name.${this.lang === 'th' ? 'th' : 'en'}`)
      params.append('status', 'Active')
      // params.append('isExactlyKeywordMatch', true)
      params.append('keyword', keyword.trim())
      let response = await seriesService.getSeriesMasterListAsync(params)
      if (response.status === 200) {
        const items = response.data.items
        this.options = items
        this.optionsText = items.map(x => x.display_name[this.lang])
        // console.log(response)
        return
      }
      console.log(response)
    },
    onSelected(val) {
      if (typeof val !== 'undefined') {
        const value = this.options.find(x => x.display_name[this.lang] === val)
        this.$emit('selected', value)
      }
    },
  },
}
</script>

<style lang="scss" scoped></style>
